// Client-side HTML sanitization using DOMPurify
// This file is client-safe and should be used in Client Components
// For Server Components, import from sanitize-html.server.ts instead

import { sanitizeHtml as clientSanitize } from './sanitize-html-client';

export { DOMPURIFY_CONFIG } from './sanitize-html-client';

export function sanitizeHtml(html: string): string {
  if (!html) return '';
  // Client-side: use DOMPurify with browser window
  return clientSanitize(html);
}
